// SMS thread — keeps the newest message in view.
//
// The card swaps whole on every send (hx-swap="outerHTML"), so without
// this the agent watches their message disappear: the rebuilt scroll
// container starts at the top, and a thread of any length puts the one
// they just sent below the fold. The composer says it worked and the
// thread appears not to have changed.
//
// Targets: [data-sms-thread] scroll container, [data-sms-composer].

export function initSMSThread(root = document) {
  root.querySelectorAll("[data-sms-thread]").forEach((thread) => {
    thread.scrollTop = thread.scrollHeight;
  });

  // Only after a swap, never on a page load: stealing focus from a
  // detail page an agent opened to read would be worse than the trip
  // back to the box.
  if (root === document) return;

  const composer = root.querySelector("[data-sms-composer]");
  if (composer) composer.focus();
}
